import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=032a66c8"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=032a66c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/home/forge/secretcircle.com/components/banner.vue').default,Breadcrumbs: require('/home/forge/secretcircle.com/components/breadcrumbs.vue').default})
